export const Bio = {
  name: "Mustafa Jebran",
  roles: [
    "Full Stack Developer",
    "Biomedical Engineer",
  ],
  description:
    "Software engineer, tech enthusiast, and lifelong learner. I specialize in building robust, user-focused applications powered by cutting-edge technologies. Driven by curiosity and a passion for innovation.",
  github: "https://github.com/MJebran",
  resume:"https://drive.google.com/file/d/1N8CldZslwDZfQLAMC0_GTi2vI3kgLZmS/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/ahmad-mustafa-jebran-63381816a/",
  insta: "https://www.instagram.com/mustafajebran/",
  discord: "mustafajebran",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Vite Js",
        image:
          "https://vitejs.dev/logo.svg",
      },
      {
        name: "Blazor",
        image:
          "https://cdn.worldvectorlogo.com/logos/blazor.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "C#",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/csharp/csharp-original.svg",
      },
      {
        name: "Fast API",
        image:
          "https://fastapi.tiangolo.com/img/logo-margin/logo-teal.png",
      },      
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Azure",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/azure/azure-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Data Science",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Pandas",
        image: "https://cdn.worldvectorlogo.com/logos/pandas.svg",
      },
      {
        name: "Numpy",
        image: "https://upload.wikimedia.org/wikipedia/commons/3/31/NumPy_logo_2020.svg",},
      {
        name: "Matplotlib",
        image: "https://cdn.worldvectorlogo.com/logos/matplotlib-1.svg",
      },
      {
        name: "Seaborn",
        image: "https://seaborn.pydata.org/_images/logo-wide-lightbg.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Kubernetes",
        image: "https://www.vectorlogo.zone/logos/kubernetes/kubernetes-icon.svg",
      },
      {
        name: "Rancher",
        image:
          "https://www.vectorlogo.zone/logos/rancher/rancher-icon.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Visual Studio",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Visual_Studio_Icon_2019.svg/1200px-Visual_Studio_Icon_2019.svg.png",
      },
      {
        name: "Postman",
        image:
          "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",},
      {
        name: "Figma",
        image:
          "https://www.vectorlogo.zone/logos/figma/figma-icon.svg",
      },
      {
        name: "Jenkins",
        image:
          "https://www.vectorlogo.zone/logos/jenkins/jenkins-icon.svg",
      },
      {
        name: "Linux",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/linux/linux-original.svg",
      },
      {
        name: "Gitea",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/b/bb/Gitea_Logo.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://snow.edu/offices/creative/brand/wallpaper/stars/stars_800x480_thumb.jpg",
    role: "DevOps & Full Stack Development Intern at Snow College",
    company: "Snow College IT department",
    date: "July 2024 - Present",
    desc: "Developing a robust portal to streamline budget tracking and inventory management for the committee and IT department. Leveraging TypeScript with React for the frontend and Python with FastAPI for the backend, supported by Oracle and PostgreSQL databases. Designed budget pages to efficiently manage fiscal year budgets and track costs. Utilized Bootstrap for responsive and modern styling, ensuring the portal is user-friendly and accessible across devices.",
    skills: [
      "TypeScript",
      "Nginx",
      "Docker",
      "Oracle",
      "PostgreSQL",
      "Python",
      "FastAPI",
    ],
    doc: "https://drive.google.com/file/d/1fAoU_ai4A0VZZsvIPFiTvXvMRPun92zs/view?usp=sharing",
  },
  {
    id: 2,
    img: "https://www.vectorlogo.zone/logos/bitwarden/bitwarden-ar21.svg",
    role: "Open Source Contributor ",
    company: "Bitwarden",
    date: "Aug 2024 - Present",
    desc: "For the issue [PM-13693] Fixed null warnings #4896, I worked on improving code stability and resolving null-related warnings within the Bitwarden project. Specifically, I addressed four issues that could lead to null errors, ensuring the code adhered to best practices and standards. The changes were part of a collaborative effort using mob programming, where I also updated a method that was previously untested and initiated discussions to include appropriate test coverage. This work contributed to enhancing the reliability and maintainability of the Bitwarden codebase. The issue is part of the Bitwarden repository and links to further details, including the #2013 GitHub issue and associated PVS-Studio analysis on C# null safety.",
    doc: "https://github.com/bitwarden/server/pull/4896",
  },
  // BenGamin
  {
    id: 1,
    img: "https://scontent-den2-1.xx.fbcdn.net/v/t39.30808-6/459326116_1028096525991609_2532026906188725865_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=6ee11a&_nc_ohc=SZmPd0fHFBYQ7kNvwGsJ9ti&_nc_oc=AdkmBeJxHGlnYAYjFvWDmQkdjHaPgyLcD7k_3Bb4hMsY5JIpXo7uF873pfpTFYDsfDo&_nc_zt=23&_nc_ht=scontent-den2-1.xx&_nc_gid=sRm5nJ0AKp8UAJ0KiYIMNw&oh=00_AfIxWEHTVYGbOC1PulSCXGCOhPZ--D1wp0QCIV6S5d-SlA&oe=681EF40A",
    role: "Full Stack Developer - BenGamin",
    company: "BenGamin",
    date: "Aug 2024 - Present",
    desc: "BenGamin is a local game store in Ephriam Utah, that sells board games and card games. The project is to create a website for BenGamin to sell their products & events online. The project is built using typescript + vite for the frontend, Python with FastAPI for the backend, and PostgreSQL for the database. The project is still in progress.",
    skills: [
      "TypeScript",
      "Vite Js",
      "Python",
      "FastAPI",
      "PostgreSQL",
      "SqaureSpace",
      "Bostrap",
      "Figma",
      "Docker",
      "Kubernetes",
      "Azure",
      "API Development",
      "Integration Testing",
      "CI/CD",
      "DevContainer",
      "Jest"
    ],
    doc: "https://www.bengamingames.com/?isinstock=true&min=0&max=500&cursor=Cg1NTDVYWDVZWVFIWTdWGiNhbmFyY2h5IHBhbmNha2VzIC1leHBsb2Rpbmcga2l0dGVucyIYRUVDNjNKU1BBWEMyWlhYWEtCSklINlo2",

  },
  {
    id: 0,
    img: "https://as2.ftcdn.net/v2/jpg/08/96/98/53/1000_F_896985371_ZhVZeA2QtMoGpUB9r8ht0H7ASoJRZdjg.jpg",
    role: "CTO & Fullstack Developer",
    company: "TrailX",
    date: "June 2024 - July 2024",
    desc: "Designed and implemented a relational database for TrailX, a hiking mobile application that provides users with personalized trail recommendations. Developed and optimized APIs to ensure seamless integration with the app’s frontend and deliver efficient, scalable performance. Contributed to building a robust backend architecture that supports user profiles, trail data, and AI-powered recommendations.",
    skills: [
      "Docker",
      "DevContainer",
      "Flttter",
      "Firebase",
      "PostgreSQL",
      "Python",
      "FastAPI",
      "Mobile Application Development",
      "Figma"
    ],
    doc: "https://github.com/orgs/the-trailx/repositories",
  },
  {
    id: 1,
    img: "https://snow.edu/offices/creative/brand/wallpaper/stars/stars_800x480_thumb.jpg",
    role: "IT Security Technician",
    company: "Snow College IT department",
    date: "Dec 2021 - Present",
    desc: "Serving as an IT Security Technician, I ensure the security and integrity of our systems by proactively safeguarding users against potential threats. Leveraging advanced tools like Adlumin, Carbon Black, and Elastic, I monitor, detect, and mitigate vulnerabilities to maintain a robust and secure IT environment.",
    skills: [
      "Adlumin",
      "Carbon Black",
      "Elastic",
      "IT Security",
      "Cybersecurity",
    ],
  },
  
  {
    id: 3,
    img: "https://scontent-den2-1.xx.fbcdn.net/v/t39.30808-6/408535849_234772539631732_2663661488723390228_n.jpg?_nc_cat=104&ccb=1-7&_nc_sid=6ee11a&_nc_ohc=WAaAOi97lH0Q7kNvwHwUYPm&_nc_oc=Adnr3d8c2D20bMfiHefltbk__s6Qexvr9Z_EsJ0o3fF5bUiWdZI748PHji1zhKbc9hk&_nc_zt=23&_nc_ht=scontent-den2-1.xx&_nc_gid=8bv6ROlqetxDDwUZoBvLKw&oh=00_AfJJrV-AX8KI0LXnuqYNaqkRw5o2mtk3SYSTJpljDnasrQ&oe=681F0D42",
    role: "Fullstack Developer - Bakery Website & Mobile App",
    company: "KaKey Bakery",
    date: "Jan 2023 - May 2023",
    desc: "Designed and developed a full-stack solution for a local bakery, enabling seamless online ordering for customers via web and mobile platforms. Built an intuitive admin panel allowing non-technical users to manage inventory and update the website effortlessly. Leveraged Blazor for the frontend, C# for the backend, and a PostgreSQL database. Deployed the application on Azure with robust API endpoints, BLOB storage, and scalable infrastructure using Docker and Kubernetes. Enhanced user experience with Figma prototypes and ensured quality with xUnit and nUnit integration tests.",
    skills: [
      "Leadership",
      "Mobile Application Development",
      "Blazor",
      "Figma",
      "C#",
      "Docker",
      "Kubernetes",
      "Azure",
      "Azure Blob Storage",
      "PostgreSQL",
      "API Development",
      "Integration Testing",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://snow.edu/offices/creative/brand/wallpaper/stars/stars_800x480_thumb.jpg",
    school: "Snow College",
    date: "Sep 2021 - May 2025",
    grade: "3.6/4.0",
    desc: "Focused on a triple concentration in Data Science, Web Development, and Entrepreneurship, combining technical expertise with innovative problem-solving and business acumen to drive impactful solutions.",
    degree: "Bachelor of Science in Software Engineering (BSSE)",
  },
  {
    id: 1,
    img: "https://d31u7wi7mdb5z3.cloudfront.net/public/provider/istanbul-kultur-university-567434/logo/41ae6076839b4e28b6a1a1b545d75c4d-istanbul-kultur-university-logo-01.png",
    school: "Istanbul Kultur University",
    date: "Sep 2020 - Sep 2021",
    grade: "4.0/4.0",
    desc: "M.S. Engineering Management – course complete May 2021",
    degree: "Engineering Management",
  },
  {
    id: 2,
    img: "https://scontent-sjc3-1.xx.fbcdn.net/v/t1.6435-9/83090060_3207134425969100_9023845345389445120_n.png?_nc_cat=100&ccb=1-7&_nc_sid=a5f93a&_nc_ohc=2Abp77QlaH4Q7kNvgGUVWWa&_nc_zt=23&_nc_ht=scontent-sjc3-1.xx&_nc_gid=AZklOCKlfPG7bg6aKQ9R5jw&oh=00_AYCZTBYhPmJuKI8DYEG6DDa2v6HnrCJMZPqzygDEgaGEiw&oe=678DFC4E",
    school: "Izmir Katip Celebi University",
    date: "Sep 2016 - Sep 2020",
    // grade: "92.3%",
    desc: "Gained a strong foundation in integrating engineering principles with medical sciences to design and develop healthcare technologies. Focused on innovative solutions for medical devices and healthcare systems, enhancing patient care and advancing biomedical research. Key areas of study included biomechanics, bioinstrumentation, and medical imaging.",
    degree: "Bachelor of Science in Biomedical Engineering",
  },
];

export const projects = [
  // {
  //   id: 9,
  //   title: "TeleHealth",
  //   date: "Nov 2024 - Present",
  //   description:
  //     "The TeleHealth Project is a web-based healthcare application designed to connect patients and doctors seamlessly. It features role-based authentication, allowing patients to submit cases and doctors to provide treatment suggestions. Built with a robust tech stack, including Next.js for the frontend, Python with FastAPI for the backend, and PostgreSQL for the database, the project emphasizes user-friendly interfaces and secure data management. Additional functionalities include case tracking, file uploads, and responsive design, providing an efficient and accessible solution for telemedicine.",
  //   image:
  //     "https://drive.google.com/file/d/1iIaIdJ7SN8eQpmPD2vKX2bU17spfikxy/view?usp=sharing",
  //   tags: [
  //     "Docker",
  //     "DuckDNS",
  //     "Eslint",
  //     "CI/CD",
  //     "React Js",
  //     "Node Js",
  //     "PostgreSQL",
  //     "C#",
  //     "EF Core",
  //   ],
  //   category: "web app",
  //   github: "https://github.com/MJebran/bakery",
  //   webapp: "https://telehealth.duckdns.org/",
  // },
  {
    id: 1,
    title: "BenGamin",
    date: "Aug 2024 - Present",
    description:
      "BenGamin is a local game store in Ephriam Utah, that sells board games and card games. The project is to create a website for BenGamin to sell their products & events online. The project is built using typescript + vite for the frontend, Python with FastAPI for the backend, and PostgreSQL for the database. The project is still in progress.",
    image:
      "https://scontent-den2-1.xx.fbcdn.net/v/t39.30808-6/459326116_1028096525991609_2532026906188725865_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=6ee11a&_nc_ohc=SZmPd0fHFBYQ7kNvwGsJ9ti&_nc_oc=AdkmBeJxHGlnYAYjFvWDmQkdjHaPgyLcD7k_3Bb4hMsY5JIpXo7uF873pfpTFYDsfDo&_nc_zt=23&_nc_ht=scontent-den2-1.xx&_nc_gid=sRm5nJ0AKp8UAJ0KiYIMNw&oh=00_AfIxWEHTVYGbOC1PulSCXGCOhPZ--D1wp0QCIV6S5d-SlA&oe=681EF40A",
    tags: ["TypeScript", "Vite Js", "Python", "FastAPI", "PostgreSQL", "SqaureSpace", "Bostrap", "Figma", "Docker", "Kubernetes", "Azure", "API Development", "Integration Testing", "CI/CD", "DevContainer", "Jest"],
    category: "web app",
    github: "https://www.bengamingames.com/?isinstock=true&min=0&max=500&cursor=Cg1NTDVYWDVZWVFIWTdWGiNhbmFyY2h5IHBhbmNha2VzIC1leHBsb2Rpbmcga2l0dGVucyIYRUVDNjNKU1BBWEMyWlhYWEtCSklINlo2",
    webapp: "https://www.bengamingames.com/?isinstock=true&min=0&max=500&cursor=Cg1NTDVYWDVZWVFIWTdWGiNhbmFyY2h5IHBhbmNha2VzIC1leHBsb2Rpbmcga2l0dGVucyIYRUVDNjNKU1BBWEMyWlhYWEtCSklINlo2",
    member: [
      {
        name: "Mustafa Jebran",
        img: "https://avatars.githubusercontent.com/u/89949006?s=400&u=1680b4e95e201e9f1e3bf5c186a3b0857a7bc8ea&v=4",
        linkedin: "https://www.linkedin.com/in/ahmad-mustafa-jebran-63381816a/",
        github: "https://github.com/MJebran",
      },
      {
        name: "Benson Bird",
        img: "https://avatars.githubusercontent.com/u/89985506?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/BensonB12",
      },
      {
        name: "Carlos Blanco",
        img: "https://avatars.githubusercontent.com/u/97683431?v=4",
        linkedin: "https://avatars.githubusercontent.com/u/97683431?v=4",
        github: "https://github.com/CarlosBlanco1",
      },
      {
        name: "Luris Solis",
        img: "https://avatars.githubusercontent.com/u/97685351?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/luris26",
      },
    ]
  },
  {
    id: 0,
    title: "Kakey Bakery",
    date: "Feb 2023 - May 2023",
    description:
      "Designed and developed a full-stack solution for a local bakery, enabling seamless online ordering for customers via web and mobile platforms. Built an intuitive admin panel allowing non-technical users to manage inventory and update the website effortlessly. Leveraged Blazor for the frontend, C# for the backend, and a PostgreSQL database. Deployed the application on Azure with robust API endpoints, BLOB storage, and scalable infrastructure using Docker and Kubernetes. Enhanced user experience with Figma prototypes and ensured quality with xUnit and nUnit integration tests.",
    image:
      "https://scontent-den2-1.xx.fbcdn.net/v/t39.30808-6/408535849_234772539631732_2663661488723390228_n.jpg?_nc_cat=104&ccb=1-7&_nc_sid=6ee11a&_nc_ohc=WAaAOi97lH0Q7kNvwHwUYPm&_nc_oc=Adnr3d8c2D20bMfiHefltbk__s6Qexvr9Z_EsJ0o3fF5bUiWdZI748PHji1zhKbc9hk&_nc_zt=23&_nc_ht=scontent-den2-1.xx&_nc_gid=8bv6ROlqetxDDwUZoBvLKw&oh=00_AfJJrV-AX8KI0LXnuqYNaqkRw5o2mtk3SYSTJpljDnasrQ&oe=681F0D42",
    tags: ["Leadership", "Mobile Application Development", "Blazor", "Figma", "C#", "Docker", "Kubernetes", "Azure", "Azure Blob Storage", "PostgreSQL", "API Development", "Integration Testing",],
    category: "web app",
    github: "https://github.com/MJebran/bakery",
    webapp: "https://kakey-mustafa.duckdns.org/",
    member: [
      {
        name: "Mustafa Jebran",
        img: "https://avatars.githubusercontent.com/u/89949006?s=400&u=1680b4e95e201e9f1e3bf5c186a3b0857a7bc8ea&v=4",
        linkedin: "https://www.linkedin.com/in/ahmad-mustafa-jebran-63381816a/",
        github: "https://github.com/MJebran",
      },
      {
        name: "Carlos Blanco",
        img: "https://avatars.githubusercontent.com/u/97683431?v=4",
        linkedin: "https://avatars.githubusercontent.com/u/97683431?v=4",
        github: "https://github.com/CarlosBlanco1",
      },
      {
        name: "Luris Solis",
        img: "https://avatars.githubusercontent.com/u/97685351?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/luris26",
      },
    ],
  },
  {
    id: 2,
    title: "Food Box",
    date: "Aug 2022 - Nov 2022",
    description:
      "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
    image: "https://img.freepik.com/premium-vector/food-box-logo-template-design_316488-1552.jpg?w=826",
    tags: ["C#", "Blazor", "API", "Docker", "Kubernetes", "Azure", "Azure Blob Storage", "PostgreSQL", "API Development", "Integration Testing"],
    category: "Web App",
    github: "https://github.com/FoodBoxTeam/FoodBox",
    webapp: "https://foodbox.duckdns.org/",
    member: [
      {
        name: "Mustafa Jebran",
        img: "https://avatars.githubusercontent.com/u/89949006?s=400&u=1680b4e95e201e9f1e3bf5c186a3b0857a7bc8ea&v=4",
        linkedin: "https://www.linkedin.com/in/ahmad-mustafa-jebran-63381816a/",
        github: "https://github.com/MJebran",
      },
      {
        name: "Benson Bird",
        img: "https://avatars.githubusercontent.com/u/89985506?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/BensonB12",
      },
      {
        name: "Luris Solis",
        img: "https://avatars.githubusercontent.com/u/97685351?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/luris26",
      },
      {
        name: "Cort",
        img: "https://avatars.githubusercontent.com/u/47114958?v=4",
        linkedin: "https://github.com/Cortlynd101",
        github: "https://github.com/Cortlynd101",
      },
    ],
  },
  {
    id: 3,
    title: "Swift Tic Tac Toe",
    date: "Sep 2023 - Apr 2022",
    description:
      "Developed a Tic Tac Toe game using Swift, featuring an intuitive and interactive interface for seamless gameplay. The project focused on implementing core game logic, user experience design, and efficient coding practices to create a smooth and engaging application. This project highlights my proficiency in Swift and my ability to build fun, user-friendly applications.",
    image:
      "https://img.freepik.com/premium-vector/tic-tac-toe-xo-icon-concept-your-design_426524-21.jpg?w=826",
    tags: ["Swift"],
    category: "IOS app",
    github: "https://github.com/MJebran/TicTac",
    webapp: "https://github.com/MJebran/TicTac",
  },
  {
    id: 10,
    title: "Flipping Houses 101",
    date: "Aug 2021 - Dec 2021",
    description:
      "I used an API to Get information about properties and I used Blazor, and C#",
    image:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAP4AAACUCAMAAACEJ2RfAAAAolBMVEX///8AAAD8/Pz19fWBgYHR0dEEBASRkZGdnZ34+Pj///3n5+eUlJTi4uLw8PDt7e1jY2PZ2dnKysoQEBA4ODhbW1sgICBPT097e3ttbW23t7caGhrDw8OpqamJiYlzc3M/Pz8vLy8oKChISEg/Sk4RKCs0QkQbLDK2vsNSWlwAFxpGU1YYJSpfZmorOkBYYWEjLS4ACxOhqq9yeoAoMDY2O0B+/XccAAAFy0lEQVR4nO2ZiXbaOhCGJdkGLxgvLF6wzZamTVO65r7/q90ZGVJsQwL3NNc05/9ONmMj9Guk2SIEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP5WlOEcXVz6pusev2WKyi7zIvLGzuvPNlDvQb0IQjnZTLezMDMrO48j74JlKJfpMr92uW4SJYyVPDCZr6erbRKmozz2jdZzR6T0rP0ujE8oKQeyy2CySWgdLL+r8/3I5xM83hyJPrUUi63J+8EL9jvi/cjXCxBNT1j/FGl94M/I/zsXRAlVTE/u/y4kWu3lvwvXJ9j8SuWbV5XTwRjIea4cZ2/9uBo2iftW8p9R5eKy7b8OwzBbs3xht+8lVt8yXkXl5pDzHMsPDOd5/9KGHl0m/xlblM0XaICZ36e0C1DNOc8531nafPxFda385e+LAV8XUoZe3wJfJpcyyzpejr24OpZzAWU8P74c0gqWE5kFfSs8jxIxG8hJ23nOvOSYZWSn85/TjGbHtjfHQriOvTiExpsknsgkUiKYNYSQQ1/nvP298Ar5q2PjL8no9GUMJ3LYt8izWFM5jURpC3/Lmo+MJ6cFPxDNOipf4PcIM49Lp4jyx5SdwA1Cu9vaSumL/O5DKaJ5084DuYkOjwwu3wGyTpLX5PCN8D7hXzM5KfvWehKfTBsJ62MezT+xE2gxDzj9LebXnP/9HiDZKntw0hk5AMWpUd9ST7BX/5nmFsuYo9SxTDa5wfrjq/VL2vnO8tGhHxnpFwu5KfoW24HcGlnFp41PGvMvlqAodSST/9xq++dX2n5eCOVUj4FwRbCrqCQM1nJ1W+mfEsaSopvwvo7qF+y7SNh0bJvnvA7anVz2BfHkMyhmOKPHSH+K/8AZhLWi+NKj2i6qknNbeUl1aFKOvnlO1dr/cmBq/Renv1wClRTnyzu2NhVOwnrk3UX1I8WCGyp/R5yWBaGp2xUufRtmNjZaad5ATob8gDG8VL6cjOgN5ddYZ81KuSL+XnBdsZGh8fKM/jfICvZEmspIfwW6ueGyXYIsVUbSFjTR9fx4Kdvn4gy8nsWPQg/LX674NLHoL3Is6Y30gpWgYjYTjkn1CE/IqdsyflIJb9URpIP2OLws/IdafV4LdZSuHH5ufPpJG6hSN7H/Vb6QM+FUDz4rj7PiV52X+NOR8Jv6WXLOk/Zml4S/hMeb/qyPfXHnZ+QGXTHactlrUlVwA+ppXht2ROzraZLehyReSvZUrog2Oc2+I8rSPjx5Xf6Korz1YAuXENH3r97j95guHHPnudwQW5R96+c8ZspdiPK+DsW5TOKMz6W+9VSIbpdrYV3Q/aR9QsHNjXbDvTcdfX7yH6hypuM//pXSwowzHRR7hWToIJx/sOqDGKd2VNLu155a5Pex6Ha5Vtr+8Yvdv4F+KthRqKwl5mY1ttNCn3dvVyldP1Ih1d8C8Cd7Wz3Pb4cupFdY46iI6tuuKr/5qhvm66SleKH7R2VOwQmOznIFW9+3LDeK/doL+ne8wFEi11F/+mki45mcsy2fk7B8s7PMJ3M/aWWUFLLTjjruWal2L6/Boo4Qh96WK+z7R2/3VDr1VayzS0r/pp3w/5bL0Rqb1Eu2++8AXMqHePk5rS9cVb8j7OoP6ofPMWkV9a4YfvzHf/jx/L+PuucTU/rf1v+G8pURWcdkcpDrNn5T/o/lftKuq+853S7HUu/qs+nvqKWF5H/5R7u++uXDB9IBShozsiLnDfV7LSGd1kMxqyJ7d7CdqxNg8lKd9E+mVP4K50z312ypp2HKLA2qXX7Q7e5vlO3wOXvLXvC4TM0j0rKddzpjQxlG63/XSllmm6UOlEbVuUFU3XamS4PSwM6z7v3QojkhmtH4D0tuCHGMBmeOmtt+mzK66NmfeJ10nvl091SWf2LYvmnL/2Pjuq8/AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANwQ/wJ6e04fJFkZ6QAAAABJRU5ErkJggg==",
    tags: ["C#", "Blazor", "API"],
    category: "Web App",
    github: "https://github.com/MJebran/Flipping-houses-101",
    webapp: "https://github.com/MJebran/Flipping-houses-101",
  },
];

// export const TimeLineData = [
//   { year: 2017, text: "Started my journey" },
//   { year: 2018, text: "Worked as a freelance developer" },
//   { year: 2019, text: "Founded JavaScript Mastery" },
//   { year: 2020, text: "Shared my projects with the world" },
//   { year: 2021, text: "Started my own platform" },
// ];
